const columns = {
  email: { id: "email", name: "Email", sortable: true, deselectable: false },
  forename: { id: "forename", name: "Forename", sortable: true, deselectable: false },
  surname: { id: "surname", name: "Surname", sortable: true, deselectable: false },
  phone: { id: "phone", name: "Phone", sortable: false, deselectable: true },
  local_id: { id: "local_id", name: "MIS ID", sortable: false, deselectable: true },
  data_ref: { id: "data_ref", name: "Xporter ID", sortable: false, deselectable: true },
  is_sync: { id: "is_sync", name: "Type", sortable: false, deselectable: true },
  no_of_students: { id: "no_of_students", name: "# Students", sortable: false, deselectable: true },
  activated_at: { id: "activated_at", name: "Activated", sortable: true, deselectable: true },
  activation_email_last_sent: { id: "activation_email_last_sent", name: "Activation Email Sent", sortable: true, deselectable: true },
  last_login: { id: "last_login", name: "Last Login", sortable: true, deselectable: true },
  created_at: { id: "created_at", name: "Created", sortable: false, deselectable: true },
  updated_at: { id: "updated_at", name: "Updated", sortable: false, deselectable: true },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false },
}

const defaultColumns = [
  "email",
  "forename",
  "surname",
  "activation_email_last_sent",
  "activated_at",
  "last_login",
  "is_sync",
  "no_of_students",
  "actions",
]

const downloadOptions = [{ key: "xls", name: "Download All XLS" }]

const filters = {
  IS_CUSTOM: { id: "IS_CUSTOM", name: "Custom" },
  IS_SYNC: { id: "IS_SYNC", name: "Sync" },
  IS_ACTIVATED: { id: "IS_ACTIVATED", name: "Activated" },
  IS_NOT_ACTIVATED: { id: "IS_NOT_ACTIVATED", name: "Not Activated" },
  IS_LOGGED_IN: { id: "IS_LOGGED_IN", name: "Has Logged In" },
  IS_NOT_LOGGED_IN: { id: "IS_NOT_LOGGED_IN", name: "Never Logged In" },
}

export { columns, defaultColumns, downloadOptions, filters }
